import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { PrizeCell } from "./PrizeCell";

export class PrizesScene extends Phaser.Scene {

    public static currentInstance: PrizesScene;
   
    private static CELLS_DELTA_X = 250;
    private static CELLS_DELTA_Y = 520;
    
    public scrolling: boolean;
    public scrollingContainerY: number;
    public scrollingContainer: Phaser.GameObjects.Container;
    public deltaY: number;

    private downY: number;

    constructor() {

        super("PrizesScene");
    }
    
    public create() {

        PrizesScene.currentInstance = this;

        GameManager.setCurrentScene(this);

        this.scrolling = false;
        this.downY = 0;

        const background = this.add.graphics();
        background.fillStyle(0xFF0000);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        this.scrollingContainerY = 0;

        this.scrollingContainer = new Phaser.GameObjects.Container(this, GameConstants.GAME_WIDTH / 2, 0);
        this.add.existing(this.scrollingContainer);

        this.scrollingContainer.y = this.scrollingContainerY;
        
        if (GameVars.aspectRatio < 1.5) {
            this.scrollingContainer.scaleX = .8;
            this.scrollingContainer.scaleY = .8 * GameVars.scaleY;
        } else {
            this.scrollingContainer.scaleY = GameVars.scaleY;
        }

        const title = new Phaser.GameObjects.Text(this, 0, 140, "ПОДАРКИ", { fontFamily: "FuturaPTBold", fontSize: "62px", color: "#FFC24B"});
        title.setOrigin(.5)
        this.scrollingContainer.add(title);

        for(let c = 0; c < 2; c++) {
            for(let r = 0; r < 5; r++) {
                const presentCell = new PrizeCell(this, c + r * 2);
                presentCell.x = PrizesScene.CELLS_DELTA_X * (2 * c - 1);
                presentCell.y = PrizesScene.CELLS_DELTA_Y * r + 500; 
                this.scrollingContainer.add(presentCell);
            }
        }

        const backButton = new Phaser.GameObjects.Image(this, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT - 180 * GameVars.scaleY, "texture_atlas_1", "btn_back");
        backButton.setInteractive();
        backButton.scaleY = GameVars.scaleY;
        backButton.on("pointerover", () => {
            backButton.setScale(1.05, 1.05 * GameVars.scaleY);
        }, this);

        backButton.on("pointerout", () => {
            backButton.setScale(1, GameVars.scaleY);
        }, this);

        backButton.on("pointerdown", () => {
            backButton.setScale(1.05, 1.05 * GameVars.scaleY);
        }, this);

        backButton.on("pointerup", () => {
            backButton.setScale(1);
            GameManager.enterRouletteScene();
            this.sound.playAudioSprite("audio-sprite", "click_btn");
        }, this);

        this.add.existing(backButton);

        this.input.on("pointerdown", this.onPointerDown, this);
        this.input.on("pointerup", this.onPointerUp, this);
    }

    public update(): void {

        if (this.scrolling) {

            this.deltaY = this.input.activePointer.y - this.downY;
            
            const y = this.deltaY + this.scrollingContainerY;

            this.scrollingContainer.y += (y - this.scrollingContainer.y) * .1;

            if (this.scrollingContainer.y > 0) {
                this.scrollingContainer.y = 0;
            } else if (this.scrollingContainer.y < 1000 / GameVars.scaleY - PrizesScene.CELLS_DELTA_Y * 4 - 25) {
                this.scrollingContainer.y = 1000 / GameVars.scaleY - PrizesScene.CELLS_DELTA_Y * 4 - 25
            }
        }
    }

    private onPointerDown(p: any): void {

        this.scrolling = true;
        this.downY = p.downY;

        this.scrollingContainerY = this.scrollingContainer.y;
    }

    private onPointerUp(p: any): void {

        this.scrolling = false;
    }
}
